import React, { useCallback, useState } from 'react';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import {
	persistFiltersOnboardingModalClosed,
	readFiltersOnboardingModalShouldShow,
} from './readFiltersOnboardingModalShouldShow.tsx';

// Lazy-loaded so the modal UI, its messages, the illustration PNGs, and all its Atlaskit
// imports are placed in a separate chunk that is only fetched for users who haven't
// dismissed the modal. Users who already dismissed it pay zero cost beyond the tiny
// localStorage check below.
const LazyFiltersOnboardingModalContent = lazyForPaint(() =>
	import(
		/* webpackChunkName: "async-jsm-insight-reports-filters-onboarding-modal" */ './FiltersOnboardingModalContent.tsx'
	).then((module) => module.default),
);

const FiltersOnboardingModal = (): React.JSX.Element | null => {
	const [isModalOpen, setIsModalOpen] = useState(() => readFiltersOnboardingModalShouldShow());

	const handleClose = useCallback(() => {
		persistFiltersOnboardingModalClosed();
		setIsModalOpen(false);
	}, []);

	if (!isModalOpen) {
		return null;
	}

	return <LazyFiltersOnboardingModalContent onClose={handleClose} />;
};

export default FiltersOnboardingModal;
